import { Group } from '@/services/network'
import { UnryoRole } from './role'

export interface UnryoNode {
  id: string
  uid: string
  label: string
  namespace: string
  group?: Group
  roles: UnryoRole[]
  timestamp: number
  url?: string
  metadata: {
    externalIp?: string
    version?: string
    usage?: {
      count: number
    }
  }
  health: {
    status: NodeStatus
    availabilityIssue?: UnryoIssue
    performanceIssue?: UnryoIssue
  }
}

export enum NodeStatus {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE'
}

export interface UnryoIssue {
  category: string
  color: string
  description: string
  icon: string
  severity: Severity
  weight: number
}

export enum Icon {
  SUCCESS = 'check_circle',
  UNKNOWN = 'help',
  MINOR = 'warning',
  MAJOR = 'error',
  CRITICAL = 'cancel'
}

export enum Severity {
  SUCCESS = 5,
  UNKNOWN = 4,
  MINOR = 3,
  MAJOR = 2,
  CRITICAL = 1
}

export enum Category {
  AVAILABILITY = 'Availability',
  PERFORMANCE = 'Performance'
}
